<template lang='pug'>
.address-container
    userCard
    .title 收货地址
    van-empty(v-if="!recipients.length", description='暂无收件信息')
    van-address-list(
        :list='recipients',
        default-tag-text='默认',
        :switchable='false',
        @add='onAdd',
        @edit='onEdit'
    )
</template>

<script>
import userCard from './components/userCard'
import AddressPanel from './components/AddressPanel'
import { getRecipients, deleteRecipient } from '@/service/member'
import { getStorage } from '@/utils/localstorage.js'
import { ORDER_ID } from '@/configs/constants'
import { mapState } from 'vuex'
export default {
    name: 'addressList',
    data() {
        return {
            address: null,
            recipients: [],
        }
    },
    components: {
        userCard, AddressPanel
    },
    async created() {
        this.$root.$emit('action', { name: this.$route.name })
        this.initData()
    },

    computed: {
        ...mapState(['memberInfo', 'userInfo', 'bookMarks', 'bookMarksLoading'])
    },
    methods: {
        onAdd() {
            this.$router.push({ name: 'addressAdd' })
        },
        onEdit({id}) {
            this.$router.push({ name: 'addressEdit', params: { id } })
        },
        async initData() {
            this.recipients = (await getRecipients()).data.map(item => {
                const { name, id, isDefault, phone, address: { province, district, city, details } } = item
                return {
                    id,
                    tel: phone,
                    address: province + city + district + details,
                    name,
                    isDefault
                }
            })
        },
        async clickDelete({ id }) {
            this.$confirm({ message: '确认要删除吗' }).then(async () => {
                await deleteRecipient(id)
                await this.initData()
            }).catch(() => {
            })

        },
    }
}
</script>

<style scoped lang='less'>
.title {
    height: 0.9rem;
    line-height: 0.9rem;
    color: #07448a;
    margin: 1rem 0rem 1.2rem 1rem;
    font-weight: 700;
}
</style>